export var CertificateBodies;
(function (CertificateBodies) {
    CertificateBodies["NIST"] = "NIST";
})(CertificateBodies || (CertificateBodies = {}));
export var CertificationTypes;
(function (CertificationTypes) {
    CertificationTypes["TEMPERATURE_PROBE_CALIBRATION"] = "TEMPERATURE_PROBE_CALIBRATION";
})(CertificationTypes || (CertificationTypes = {}));
